import { sanitizeComment, updateComment, updateReply } from "../helpers/tools";

export const initialState = {
  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  collection: []
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "COMMENTS_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null
      };

    case "COMMENTS_FETCH_FULFILLED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: true,

        collection: action.data
      };

    case "COMMENTS_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: action.data
      };

    case "COMMENT_LIKE_FULFILLED":
    case "COMMENT_UNLIKE_FULFILLED":
      return {
        ...state,
        collection: state.collection.map(i =>
          updateComment(i, action.data.data)
        )
      };

    case "COMMENT_CREATE_FULFILLED":
      return {
        ...state,
        collection:
          action.data.reply_id > 0
            ? state.collection.map(i =>
                updateReply(i, sanitizeComment(action.data))
              )
            : [sanitizeComment(action.data), ...state.collection]
      };

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        collection: state.collection
      };

    case "LOGOUT":
      return {
        ...initialState
      };

    default:
      return state;
  }
}
